import React, { Component } from 'react';
import _ from 'underscore';
import { ButtonToolbar, Button , Alert} from 'react-bootstrap';
import { mixinsClassName, fetch, urls, guid, postMessage, urlParams } from '../../utils';
import Script from 'react-load-script';

let captureObj;
let captureDir = `/static_cmps/NiuniuCapture/180509`;

export default class Caprure extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMac: false,
            isAlertVisible: false,
            captureDownLoadTipUrl: '',
            isLoadScript: false
        }
    }
    componentDidMount() {
        let platform = navigator.platform;
        this.setState({
            isMac: platform.indexOf('Mac') === 0
        });
        this._initCapture();
    }
    _initCapture() {
        console.log('_initCapture');
        this.setState({
            isLoadScript: true
        })
        
    }
    _startCapture() {
        //从返回值来解析显示   
        if (!captureObj) {
            return this._initCapture();
        }
        let captureRet = captureObj.DoCapture("1.jpg", 0, 3, 0, 0, 0, 0);
        if (captureRet) {
            this._showCaptureDownLoadTip();
        }
    }
    _getNiuniuCaptureUrl (type) {
        let isMac = this.state.isMac;
        let parentUrl = window.document.referrer || "";
        let parentUrlObj = new URL(parentUrl) || {};
        if (type === 'js') {
            return `${parentUrlObj.origin}${captureDir}/niuniucapture.js`
        } else {
            return `${parentUrlObj.origin}${captureDir}/CaptureInstall.${isMac ?'dmg':'exe'}`;
        }
    }
    _showCaptureDownLoadTip() {
        this.setState({
            isAlertVisible: true,
            captureDownLoadTipUrl: this._getNiuniuCaptureUrl() 
        })
    }
    
    handleClickCapture() {
        console.log('click');
        this._startCapture();
    }
    handleAlertDismiss(ev) {
        console.log('Alertclose')
        this.setState({
            isAlertVisible: false,
            captureDownLoadTipUrl: ''
        });
        ev.stopPropagation();
    }
    handleScriptLoad() {
        console.log('handleScriptLoad');
        let that = this;
        let finishedCallback = function(type, x, y, width, height, info, content, localpath) {
            console.log("finishedCallback");
            if (type < 0) //需要重新安装控件
                return this.showCaptureDownLoadTip();

            if (_.contains([1, 4], type)) {
                if (type === 4 && info != '0') {
                    return;
                }
                that.props.onCaptureAction && that.props.onCaptureAction({
                    src: "data:image/png;base64," + content,
                    content: content
                })
                // self.sendAction("action", {
                //     src: "data:image/png;base64," + content,
                //     content: content
                // });
            }
        };
        let pluginLoadedCallback = function() {};
        let versionCallback = function() {};
        captureObj = new window.NiuniuCaptureObject();
        captureObj.NiuniuAuthKey = "niuniu";

        captureObj.FinishedCallback = finishedCallback;
        captureObj.PluginLoadedCallback = pluginLoadedCallback;
        captureObj.VersionCallback = versionCallback;
        captureObj.InitNiuniuCapture();
        
    }
    render() {
        return (
            <div className="editor-capture-wrapped">
                {
                    this.state.isAlertVisible ? (
                        <Alert className="alert-tip" bsStytle="danger" onDismiss={this.handleAlertDismiss.bind(this)}>
                            正在截图中, 如果超过5秒无响应，请点此
                            <a class="btn-download" target="_blank" href={this.state.captureDownLoadTipUrl}>安装</a>
                        </Alert>
                    ) : null
                }
                <a className="icon icon-jianqie editor-capture" onClick={this.handleClickCapture.bind(this)}></a>
                {
                    this.state.isLoadScript ? <Script url={this._getNiuniuCaptureUrl('js')} onLoad={this.handleScriptLoad.bind(this)} /> : null
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/ui/capture/index.js